window.api = {};

api.fetch = (url, requestObject = {}) => {
  return axios({
      url,
      method: requestObject.method || 'get',
      data: requestObject.data || null,
      params: requestObject.params || null,
      headers: {
        Accept: 'application/json',
        ...requestObject.headers
      }
    })
    .then(response => response.data)
    .catch(error => {
      const errorResponse = error.response && error.response.data;
      if (errorResponse && errorResponse.message) {
        Vue.$toast.error(errorResponse.message.replace(/<br>/g, '\n'));
      }
      throw errorResponse;
    });
}
